import { FaFacebook, FaInstagram, FaLinkedin, FaXTwitter } from "react-icons/fa6";
import { MdLocationOn, MdEmail, MdCall } from "react-icons/md";
import { useNavigate } from "react-router-dom";

export default function Footer() {
  const navigate=useNavigate();
  return (
    <footer className="bg-zinc-800 text-white px-6 py-3 mt-5">
      <div className="w-full px-3 md:px-4 flex flex-col md:flex-row gap-5 md:gap-2">

        <div className="text-[10px] md:text-xs xl:text-sm 2xl:text-base w-full md:w-1/6">
          <h2 className="text-xs md:text-sm xl:text-base font-semibold mb-2 md:mb-4">Quick Links</h2>
          <ul className="space-y-2">
            <li onClick={()=>navigate("/")} className="hover:underline">Home</li>
            <li>About us</li>
            <li onClick={()=>navigate("/productpage")} className="hover:underline">Products</li>
            <li onClick={()=>navigate("/service")} className="hover:underline">Services</li>
          </ul>
        </div>

        <div className="text-[10px] md:text-xs xl:text-sm 2xl:text-base w-full md:w-1/6">
          <h2 className="text-xs md:text-sm xl:text-base font-semibold mb-2 md:mb-4">Need Help?</h2>
          <ul className="space-y-2">
            <li onClick={()=>navigate("/faqpage")} className="hover:underline">FQA</li>
            <li onClick={()=>navigate("/returnpolicy")} className="hover:underline">Return Policy</li>
            <li onClick={()=>navigate("/privatepolicy")} className="hover:underline">Private Policy</li>
          </ul>
        </div>

        <div className="text-[10px] md:text-xs xl:text-sm 2xl:text-base w-full md:w-1/6">
          <h2 className="text-xs md:text-sm xl:text-base font-semibold mb-2 md:mb-4">Newsletter</h2>
          <form className="space-y-3">
            <input
              type="email"
              placeholder="Email"
              className="w-full px-2 py-2 rounded bg-black text-white border border-white focus:outline-none placeholder-gray-100"
            />
            <button
              type="submit"
              className="w-full bg-white text-black py-2 rounded hover:bg-gray-300 transition"
            >
              Subscribe
            </button>
          </form>
        </div>
     
        <div className="text-[10px] md:text-xs xl:text-sm 2xl:text-base w-full md:w-2/6 md:pl-7">
          <h2 className="text-xs md:text-sm xl:text-base font-semibold mb-2 md:mb-4">Contact us</h2>
          <div className="text-[10px] md:text-xs xl:text-sm 2xl:text-base flex flex-col gap-2 md:gap-3">
            <div className="flex items-start gap-2">
              <MdLocationOn className="text-2xl md:text-4xl xl:text-3xl" />
              <p>Shop No.-11, 1577, BhagyaNagari Society, Tilak Road, Sadashiv Peth, Pune</p>
            </div>
            <div className="flex items-center gap-2">
              <MdCall className="text-lg md:text-lg xl:text-xl" />
              <span>+91-234-345-5678</span>
            </div>
            <div className="flex items-center gap-2">
              <MdEmail className="text-base md:text-xl xl:text-xl" />
              <span>asialinkscomputers@gmail.com</span>
            </div>
          </div>
        </div>

        <div className="w-full md:w-1/6 md:pl-7">
          <h2 className="text-xs md:text-sm xl:text-base font-semibold mb-2 md:mb-4">Follow us</h2>
          <div className="flex flex-row gap-2 xl:gap-3">
            <a href="https://linkdin.com" target="_blank" rel="noopener noreferrer">
              <FaLinkedin size={20} className="hover:text-blue-500 cursor-pointer" />
            </a>
            <a href="https://facebook.com" target="_blank" rel="noopener noreferrer">
              <FaFacebook size={20} className="hover:text-blue-700 cursor-pointer" />
            </a>
            <a href="https://instagram.com" target="_blank" rel="noopener noreferrer">
               <FaInstagram size={20} className="hover:text-pink-500 cursor-pointer" />
            </a>
            <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">
              <FaXTwitter size={20} className="hover:text-gray-400 cursor-pointer" />
            </a>          
          </div>
        </div>
      </div>
    </footer>
  );
}
